import React from 'react';
import { Modal } from 'antd';
import JSONViewer from './JSONViewer';

export default function JSONViewerModal({ visible, onClose, json, title = 'JSON Viewer' }) {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      onOk={onClose}
      title={title}
      width={800}
      bodyStyle={{ maxHeight: 600, overflow: 'auto' }}
      footer={null}
      destroyOnClose
    >
      <JSONViewer json={json} />
    </Modal>
  );
}
